export default __webpack_public_path__ + "static/media/LocofastInNews_03.bc69c7b7.webp";